import React, { useState } from 'react'
import { getUserDetailByLoanIdOptimisedApi, logAdminApi } from '../../AdminActionCreator.component'
import AssignedLeadsOlderThanDay from './AssignedLeadsOlderThanDayNew';
import UserDetail from '../../CustomerPages/UserDetailMainNew.container';
import Loader from '../../../../presentationals/Loader/Loader.component'
import AssignedLeadCount from './AssignedLeadCountNewlatest';

const actionButtonState = true;
const markCompleteBtn = true;
export default function CustomInfoOption({ admin, setDetailsPage,viewType,allStatus,handlePageState }) {

    const [loader, setLoader] = useState(false)
    const [userState, setuserState] = useState(true)
    const [viewState, setviewState] = useState(false)
    const [allDetail, setallDetail] = useState([])
    const [userDetail, setuserDetail] = useState([])
    const [dataChange, setdataChange] = useState("")

    const userDetailHandler = (userData) => {
        logAdminApi(userData?.assignUser, userData.loanId, callback => {
            console.log(callback)
        })
        setLoader(false)
        setDetailsPage(true)

        getUserDetailByLoanIdOptimisedApi(userData.loanId, userData.userId,
            (callBack) => {
                setLoader(false)
                setuserState(false)
                setviewState(true)
                setallDetail(callBack)
                setuserDetail(userData)
            })
    }

    const backHandler = () => {
        setuserState(true)
        setviewState(false)
        if (dataChange == 'yes') {
            // this.getLoanLead() main api call here
            setdataChange("")
        }
    }

    const getData = (data) => {
        setdataChange(data)
    }

    return (
        <>
        <div className="full-height" style={{marginTop : viewState == true ? "75px" : ""}}>
        {loader ? <Loader /> :''}
            {viewState == true ?
                <UserDetail
                    userDetailHandler={userDetailHandler}

                    getData={getData}
                    leadManagementData={userDetail}
                    allDetail={allDetail}
                    userDetails={userDetail}
                    admin={admin}
                    backHandler={backHandler}
                    actionButtonState={actionButtonState}
                    markCompleteBtn={markCompleteBtn}
                    setDetailsPage={setDetailsPage}
                    handlePageState={handlePageState}
                />
                : ""}
            {
                userState == true && viewType == "AssignedLeadsOlderThanDay" ?
                    <AssignedLeadsOlderThanDay
                    userDetailHandler={userDetailHandler}
                       allStatus={allStatus}
                    admin={admin}
                    />
                    : ''}
            {
                userState == true && viewType == "leadcount" ?
                    <AssignedLeadCount
                    userDetailHandler={userDetailHandler}
                    />
                    : ''}
                    </div>
        </>
    )
}
